import React, { useEffect, useState } from 'react';
import { Col, Form, Row } from 'react-bootstrap';
import decisionValues from "../../openPosition.json";
import DatePicker from 'react-datepicker';
import 'react-datepicker/dist/react-datepicker.css';
import moment from 'moment';
import TimePicker from 'rc-time-picker';
import 'rc-time-picker/assets/index.css'
import Api from '../../../api/api';
import { useMyContext } from '../../../context/MyContext';

const OpenDecisionInputs = (props) => {
    const { strategyObject } = useMyContext();

    const [searchTerm, setSearchTerm] = useState('');
    const [symbols, setSymbols] = useState([]);
    const [searchString, setSearchString] = useState('');
    const [showDropdown, setShowDropdown] = useState(false);
    const options = decisionValues.fieldData[props.label.split(",")[1]];
    // Filter the options based on the search term 
    const filteredOptions = (props.label.split(",")[1] !== "number" && props.label.split(",")[1] !== "dttm" && props.label.split(",")[1] !== "time" && props.label.split(",")[1] !== "text") ? options.filter(option =>
        option.toLowerCase().includes(searchTerm.toLowerCase())
    ) : [];
    const [selectedDate, setSelectedDate] = useState(new Date());
    const [selectedTime, setSelectedTime] = useState();

    const updateInput = (val, type) => {
        let preData = props.decisionValue;
        if (type == "date") {
            setSelectedDate(val);
            preData[props.mainIndex][props.index] = moment(val).format("MM-DD-YYYY HH:mm");
        } else if (type == "time") {
            setSelectedTime(val);
            preData[props.mainIndex][props.index] = moment(val).format("HH:mm");
        } else {
            preData[props.mainIndex][props.index] = val;
            // Close dropdown and set search string when a symbol is selected
            if (props.type === 'select' && props.label.split(",")[0] === 'symbol') {
                setShowDropdown(false);
                setSearchString(val); // Set the search string to the selected value
                
                // Find the selected symbol's ins_type
                const selectedSymbol = symbols.find(symbol => symbol.z_symbol === val);
                if (selectedSymbol) {
                    // Call parent callback to update positionType if provided
                    props.onPositionTypeChange(selectedSymbol.ins_type);
                }
            }
        }
        props.setDecisionValue(preData);
    }

    const handleSelectChange = (event) => {
        const { options } = event.target;
        const selectedValues = [];
        for (let i = 0; i < options.length; i++) {
            if (options[i].selected) {
                selectedValues.push(options[i].value);
            }
        }
        let preData = props.decisionValue;
        preData[props.mainIndex][props.index] = event.target.value;
        props.setDecisionValue(preData);
    };

    const getSymbols = async () => {
        try {
            const res = await Api.symbols(searchString);
            //console.log(JSON.parse(res.search_string));
            setSymbols(JSON.parse(res.search_string))
        } catch (error) {
            console.error("Error fetching symbols:", error);
        }
    };

    const handleSearchInput = (value) => {
        setSearchString(value);
    };

    useEffect(() => {
        if (searchString.length >= 3) {
            const delayDebounce = setTimeout(() => {
                getSymbols()
            }, 300);

            return () => clearTimeout(delayDebounce);
        } else if (searchString.length === 0) {
            setSymbols([])
        }
    }, [searchString]);

    // Handle clicking outside dropdown to close it
    useEffect(() => {
        const handleClickOutside = (event) => {
            if (showDropdown && !event.target.closest('.custom-dropdown')) {
                setShowDropdown(false);
            }
        };

        document.addEventListener('mousedown', handleClickOutside);
        return () => {
            document.removeEventListener('mousedown', handleClickOutside);
        };
    }, [showDropdown]);

    const filteredSymbos = symbols?.filter(option =>
        option.ins_type !== 'IND' && option.z_symbol?.toLowerCase().includes(searchString.toLowerCase())
    ).sort((a, b) => {
        const searchLower = searchString.toLowerCase();
        const aName = a.z_symbol?.toLowerCase() || '';
        const bName = b.z_symbol?.toLowerCase() || '';
        
        const aStartsWith = aName.startsWith(searchLower);
        const bStartsWith = bName.startsWith(searchLower);
        
        // If one starts with search string and other doesn't, prioritize the one that starts with it
        if (aStartsWith && !bStartsWith) return -1;
        if (!aStartsWith && bStartsWith) return 1;
        
        // If both start with or both don't start with, sort alphabetically
        return aName.localeCompare(bName);
    });

    const updateSymbols = (value) => {
        setShowDropdown(false);
    };

    useEffect(() => {
        let preData = localStorage.getItem('decisionValue');
        if (preData != null) {
            preData = JSON.parse(preData);
            if (preData[props.mainIndex] != undefined) {
                let newObj = {
                    [props.mainIndex]: preData[props.mainIndex]
                }
                props.setDecisionValue(newObj);
            }
        }
    }, []);

    return (
        <>
            <Form.Group as={Row} className='mt-2' >
                <span>
                    <Form.Label sm={2} className='font-weight-bold' style={{ fontWeight: '600', textTransform: "capitalize" }}>
                        {props.label?.split(",")[0]} </Form.Label>
                    {props.type == 'number' && <Col sm={10}>
                        <Form.Control type="number" value={props.decisionValue[props.mainIndex][props.index]}
                            onChange={e => updateInput(e.target.value)} placeholder="Enter a number" />
                    </Col>}
                </span>
                <span>
                    {props.type == 'search' && <Col sm={10}>
                        <input
                            type="text"
                            placeholder="Search"
                            size="sm"
                            value={searchTerm}
                            onChange={e => setSearchTerm(e.target.value)}
                            style={{
                                padding: '3px',
                                borderRadius: '5px',
                                border: '1px solid #EAEAEA',
                                width: '30%', display: 'none'
                            }}
                        />
                        <select className='form-control' onChange={e => updateInput(e.target.value)} value={props.decisionValue[props.mainIndex][props.index]}>
                            {filteredOptions.map((option, index) => (
                                <option key={index} value={option}>
                                    {option}
                                </option>
                            ))}
                        </select>
                    </Col>}
                </span>
                <span>
                    {props.type == 'multiselect' && <Col sm={10}>
                        <Form.Select
                            multiple
                            value={props.decisionValue[props.mainIndex][props.index]}
                            onChange={handleSelectChange}
                        >
                            {filteredOptions.map((option, index) => (
                                <option key={index} value={option}>
                                    {option}
                                </option>
                            ))}
                        </Form.Select>
                    </Col>}
                </span>
                <span>
                    {props.type === 'select' && props.label.split(",")[0] !== 'symbol' && <Col sm={10}>
                        <Form.Select
                            value={props.decisionValue[props.mainIndex][props.index]}
                            onChange={e => updateInput(e.target.value)}
                        >
                            <option key="0" value="">
                                Select a value
                            </option>
                            {filteredOptions.map((option, index) => (
                                <option key={index} value={option}>
                                    {option}
                                </option>
                            ))}
                        </Form.Select>
                    </Col>}
                </span>
                <span>
                    {props.type === 'select' && props.label.split(",")[0] === 'symbol' && (
                        <Col sm={10}>
                            <div className="custom-dropdown" style={{ position: 'relative' }}>
                                <Form.Control
                                    type="text"
                                    placeholder="Search..."
                                    value={searchString}
                                    onChange={e => handleSearchInput(e.target.value)}
                                    onFocus={() => setShowDropdown(true)}
                                    onBlur={() => setTimeout(() => setShowDropdown(false), 200)}
                                />
                                {showDropdown && (
                                    <div className="dropdown-options symbol-dropdown-wrapper" style={{ 
                                        position: 'absolute', 
                                        top: '100%', 
                                        left: 0, 
                                        right: 0, 
                                        zIndex: 1000,
                                        backgroundColor: 'white',
                                        border: '1px solid #ccc',
                                        borderRadius: '4px',
                                        maxHeight: '300px',
                                        overflowY: 'auto'
                                    }}>
                                        {filteredSymbos.map((option, index) => (
                                            <div
                                                key={index}
                                                className="option"
                                                onClick={() => updateInput(option.z_symbol)}
                                                style={{
                                                    padding: '8px 12px',
                                                    cursor: 'pointer',
                                                    borderBottom: '1px solid #eee'
                                                }}
                                                onMouseEnter={(e) => e.target.style.backgroundColor = '#f5f5f5'}
                                                onMouseLeave={(e) => e.target.style.backgroundColor = 'white'}
                                            >
                                                {option.z_symbol}
                                            </div>
                                        ))}
                                    </div>
                                )}
                            </div>
                        </Col>
                    )}
                </span>
                <span>
                    {props.type == 'dttm' && <Col sm={10}>
                        <div className='date-time-picker'>
                            <DatePicker
                                selected={selectedDate}
                                // onChange={handleChange}
                                showTimeSelect
                                timeIntervals={5}
                                dateFormat="MMMM d, yyyy h:mm aa"
                                className='form-control date-picker'
                                onChange={e => updateInput(e, "date")}
                            />
                        </div>
                    </Col>}
                </span>
                <span>
                    {props.type == 'time' && <Col sm={10}>
                        <div className='date-time-picker'>
                            <TimePicker
                                showHour
                                showSecond={false}
                                defaultValue={selectedTime}
                                onChange={e => updateInput(e, "time")}
                            />
                        </div>
                    </Col>}
                </span>
                <span>
                    {props.type == 'text' && <Col sm={10}>
                        <div>
                            <input type='text' className='form-control' onChange={(e) => updateInput(e.target.value)} />
                        </div>
                    </Col>}
                </span>
            </Form.Group>
        </>
    );
};

export default OpenDecisionInputs;
